import React from "react"

export default function Loading() {
	return (
		<div className="jam--container">
			<img
				src="https://strawberryjam.nyc3.cdn.digitaloceanspaces.com/icon.png"
				className="jam--loading-logo"
			/>
			<style>{`
				.jam--container {
					-webkit-box-align: center;
					-ms-flex-align: center;
					align-items: center;
					cursor: default;
					display: -webkit-box;
					display: -ms-flexbox;
					display: flex;
					height: 100%;
					-webkit-box-pack: center;
					-ms-flex-pack: center;
					justify-content: center;
					position: fixed;
					left: 0;
					top: 0;
					width: 100%;
					z-index: 9000;
					transition: opacity 0.2s linear;
					z-index: 1000001;
				}

				.jam--loading-logo {
					-webkit-animation: spinner 2s infinite linear;
					animation: spinner 2s infinite linear;
					height: 5em;
					margin: 0 auto 3.5em auto;
					width: 5em;
				}

				@-webkit-keyframes spinner {
					to {
						-webkit-transform: rotateZ(360deg);
						transform: rotateZ(360deg);
					}
				}

				@keyframes spinner {
					to {
						-webkit-transform: rotateZ(360deg);
						transform: rotateZ(360deg);
					}
				}
			`}</style>
		</div>
	)
}
